import Backdraft from "backdraft-app/src/backdraft";

import ActionBar from "shared/components/action_table/action_bar";
import ActionTable from "shared/components/action_table";

import inlineEditColumnType from "shared/components/action_table/inline_edit_column_type";

function defineDataTableClassProperty(name, actionTableClass, views) {
  const descriptor = Object.create(null);
  descriptor.get = function() {
    return views[this.dataTableClassName];
  };

  Object.defineProperty(actionTableClass.prototype, 'dataTableClass', descriptor);
}

Backdraft.plugin("ActionTable", plugin => {
  plugin.initializer(app => {
    // dependencies
    app.installPlugin("Base");
    app.installPlugin("DataTable");

    app.view.dataTable.config.addColumnType(inlineEditColumnType);

    app.view.actionTable = function(name, baseClassName, properties) {
      let baseClass = ActionTable;
      if (arguments.length === 2) {
        properties = baseClassName;
      } else {
        baseClass = app.Views[baseClassName];
      }

      const actionTableClass = baseClass.extend(properties);

      app.Views[name] = actionTableClass;

      defineDataTableClassProperty(name, actionTableClass, app.Views);
    };
  });

  plugin.exports({
    ActionBar,
    ActionTable
  });
});
